module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-lightest WidgetCostumizeContainer"
  }, [(!_vm.selectedWidget || _vm.selectedWidget == null) ? _c('div', [_vm._v("\n        Loading Widget\n    ")]) : _c('div', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-6"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "iframeContainerParent d-flex justify-content-center my-3"
  }, [_c('div', {
    staticClass: "iframeContainer"
  }, [_c('div', {
    staticClass: "dark iframeLabel"
  }, [_vm._v("Iframe Container")]), _vm._v(" "), _c('iframe', {
    staticClass: "iframeExample",
    style: (_vm.widgetStyle),
    attrs: {
      "src": _vm.widgetLink,
      "height": "600",
      "allow": "payment"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "controlsHolder border-light radius-normal py-1"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('div', {
    staticClass: "flex-grow-1 d-flex justify-content-between pr-3"
  }, [_c('div', [_vm._v("Width:")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('checkbox', {
    staticClass: "mr-1",
    attrs: {
      "value": "true"
    },
    model: {
      value: (_vm.widgetSettings.fullWidth),
      callback: function($$v) {
        _vm.$set(_vm.widgetSettings, "fullWidth", $$v)
      },
      expression: "widgetSettings.fullWidth"
    }
  }), _vm._v("Use 100% *")], 1)]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fas fa-minus-circle fs-larger dark mx-0",
    on: {
      "click": function($event) {
        return _vm.decreaseValue('width', _vm.limits.widthMin, _vm.widgetSettings.fullWidth)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.widgetSettings.width),
      expression: "widgetSettings.width"
    }],
    staticClass: "text-center darker bg-lighter border-medium radius-normal py-1 px-0 mx-1",
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "type": "number",
      "value": "0",
      "disabled": _vm.widgetSettings.fullWidth
    },
    domProps: {
      "value": (_vm.widgetSettings.width)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.widgetSettings, "width", $event.target.value)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "lazy", undefined, $event.key, undefined)) { return null; }
        return _vm.valueManuallyChanged($event, 'width', _vm.limits.widthMin, _vm.limits.widthMax)
      }]
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-plus-circle fs-larger dark mx-0",
    on: {
      "click": function($event) {
        return _vm.increaseValue('width', _vm.limits.widthMax, _vm.widgetSettings.fullWidth)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('div', {
    staticClass: "flex-grow-1 d-flex justify-content-between pr-3"
  }, [_c('div', [_vm._v("Height:")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('checkbox', {
    staticClass: "mr-1",
    attrs: {
      "value": "true"
    },
    model: {
      value: (_vm.widgetSettings.fullHeight),
      callback: function($$v) {
        _vm.$set(_vm.widgetSettings, "fullHeight", $$v)
      },
      expression: "widgetSettings.fullHeight"
    }
  }), _vm._v("Use 100% *")], 1)]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fas fa-minus-circle fs-larger dark mx-0",
    on: {
      "click": function($event) {
        return _vm.decreaseValue('height', _vm.limits.heightMin, _vm.widgetSettings.fullHeight)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.widgetSettings.height),
      expression: "widgetSettings.height"
    }],
    staticClass: "text-center darker bg-lighter border-medium radius-normal py-1 px-0 mx-1",
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "type": "number",
      "value": "0",
      "disabled": _vm.widgetSettings.fullHeight
    },
    domProps: {
      "value": (_vm.widgetSettings.height)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.widgetSettings, "height", $event.target.value)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "lazy", undefined, $event.key, undefined)) { return null; }
        return _vm.valueManuallyChanged($event, 'height', _vm.limits.heighthMin, _vm.limits.heightMax)
      }]
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-plus-circle fs-larger dark mx-0",
    on: {
      "click": function($event) {
        return _vm.increaseValue('height', _vm.limits.heightMax, _vm.widgetSettings.fullHeight)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_vm._v("Top Margin:")]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fas fa-minus-circle fs-larger dark mx-0",
    on: {
      "click": function($event) {
        return _vm.decreaseValue('topMargin', _vm.limits.marginMin, false)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.widgetSettings.topMargin),
      expression: "widgetSettings.topMargin"
    }],
    staticClass: "text-center darker bg-lighter border-medium radius-normal py-1 px-0 mx-1",
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "type": "number",
      "value": "0"
    },
    domProps: {
      "value": (_vm.widgetSettings.topMargin)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.widgetSettings, "topMargin", $event.target.value)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "lazy", undefined, $event.key, undefined)) { return null; }
        return _vm.valueManuallyChanged($event, 'topMargin', _vm.limits.marginMax, _vm.limits.marginMin)
      }]
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-plus-circle fs-larger dark mx-0",
    on: {
      "click": function($event) {
        return _vm.increaseValue('topMargin', _vm.limits.marginMax, false)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_vm._v("Bottom Margin:")]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fas fa-minus-circle fs-larger dark mx-0",
    on: {
      "click": function($event) {
        return _vm.decreaseValue('bottomMargin', _vm.limits.marginMin, false)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.widgetSettings.bottomMargin),
      expression: "widgetSettings.bottomMargin"
    }],
    staticClass: "text-center darker bg-lighter border-medium radius-normal py-1 px-0 mx-1",
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "type": "number",
      "value": "0"
    },
    domProps: {
      "value": (_vm.widgetSettings.bottomMargin)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.widgetSettings, "bottomMargin", $event.target.value)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "lazy", undefined, $event.key, undefined)) { return null; }
        return _vm.valueManuallyChanged($event, 'bottomMargin', _vm.limits.marginMax, _vm.limits.marginMin)
      }]
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-plus-circle fs-larger dark mx-0",
    on: {
      "click": function($event) {
        return _vm.increaseValue('bottomMargin', _vm.limits.marginMax, false)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_vm._v("Bottom Left:")]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fas fa-minus-circle fs-larger dark mx-0",
    on: {
      "click": function($event) {
        return _vm.decreaseValue('leftMargin', _vm.limits.marginMin, false)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.widgetSettings.leftMargin),
      expression: "widgetSettings.leftMargin"
    }],
    staticClass: "text-center darker bg-lighter border-medium radius-normal py-1 px-0 mx-1",
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "type": "number",
      "value": "0"
    },
    domProps: {
      "value": (_vm.widgetSettings.leftMargin)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.widgetSettings, "leftMargin", $event.target.value)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "lazy", undefined, $event.key, undefined)) { return null; }
        return _vm.valueManuallyChanged($event, 'leftMargin', _vm.limits.marginMax, _vm.limits.marginMin)
      }]
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-plus-circle fs-larger dark mx-0",
    on: {
      "click": function($event) {
        return _vm.increaseValue('leftMargin', _vm.limits.marginMax, false)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_vm._v("Bottom Right:")]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fas fa-minus-circle fs-larger dark mx-0",
    on: {
      "click": function($event) {
        return _vm.decreaseValue('rightMargin', _vm.limits.marginMin, false)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.widgetSettings.rightMargin),
      expression: "widgetSettings.rightMargin"
    }],
    staticClass: "text-center darker bg-lighter border-medium radius-normal py-1 px-0 mx-1",
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "type": "number",
      "value": "0"
    },
    domProps: {
      "value": (_vm.widgetSettings.rightMargin)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.widgetSettings, "rightMargin", $event.target.value)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "lazy", undefined, $event.key, undefined)) { return null; }
        return _vm.valueManuallyChanged($event, 'rightMargin', _vm.limits.marginMax, _vm.limits.marginMin)
      }]
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-plus-circle fs-larger dark mx-0",
    on: {
      "click": function($event) {
        return _vm.increaseValue('rightMargin', _vm.limits.marginMax, false)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end mb-1"
  }, [_c('button', {
    staticClass: "btn tertiary small",
    on: {
      "click": function($event) {
        return _vm.loadDefaults()
      }
    }
  }, [_vm._v("Load defaults")])])]), _vm._v(" "), _c('div', {
    staticClass: "dark fs-small"
  }, [_vm._v("\n                                * Using 100% will make the widget fit the limits of the container.\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "darker fs-largest my-3"
  }, [_vm._v("\n                                Widget code\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "bg-lighter darkest border-dark radius-normal p-2 darkest"
  }, [_vm._v("\n                                " + _vm._s(_vm.iframeCode) + "\n                            ")])]), _vm._v(" "), _vm._m(2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "darker fs-largest my-3"
  }, [_vm._v("\n                        Costumize your widget according to your needs\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 mb-3"
  }, [_c('div', {
    staticClass: "darker fs-largest my-3"
  }, [_vm._v("\n                                Widget Rules\n                            ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                                    The widget can not have any other element covering it\n                                ")]), _vm._v(" "), _c('li', [_vm._v("\n                                    The minium width of the widget is 300px\n                                ")]), _vm._v(" "), _c('li', [_vm._v("\n                                    The minium height of the widget is 450px\n                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "darker fs-largest my-3"
  }, [_vm._v("\n                                Notes\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "notesLines"
  }, [_c('div', [_vm._v("- You can send this link to the persone responsible for your website.")]), _vm._v(" "), _c('div', [_vm._v("- After changing your widget settings you must copy the widget code and paste it on you website code.")]), _vm._v(" "), _c('div', [_vm._v("- The settings used on this tool are not saved, everytime this tool is opened it starts with the default values.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f0dccd6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widget/WidgetCostumize.vue
// module id = 2696
// module chunks = 0